import { render, staticRenderFns } from "./BuilderCategoriesPopup.vue?vue&type=template&id=1fa8ad44&scoped=true&"
import script from "./BuilderCategoriesPopup.vue?vue&type=script&lang=js&"
export * from "./BuilderCategoriesPopup.vue?vue&type=script&lang=js&"
import style0 from "./BuilderCategoriesPopup.vue?vue&type=style&index=0&id=1fa8ad44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8ad44",
  null
  
)

export default component.exports